/**
 * ITU-T E.164 国家/地区呼叫码。
 * 同一呼叫码（如 +1、+7）合并为一条，供手机号国家码选择。
 * 格式：[code, iso, zh, en]
 */
const COUNTRY_CALLING_CODES = [
  [86, "CN", "中国", "China"],
  [852, "HK", "中国香港", "Hong Kong"],
  [853, "MO", "中国澳门", "Macao"],
  [886, "TW", "中国台湾", "Taiwan"],
  [81, "JP", "日本", "Japan"],
  [82, "KR", "韩国", "South Korea"],
  [65, "SG", "新加坡", "Singapore"],
  [60, "MY", "马来西亚", "Malaysia"],
  [66, "TH", "泰国", "Thailand"],
  [84, "VN", "越南", "Vietnam"],
  [62, "ID", "印度尼西亚", "Indonesia"],
  [63, "PH", "菲律宾", "Philippines"],
  [855, "KH", "柬埔寨", "Cambodia"],
  [856, "LA", "老挝", "Laos"],
  [95, "MM", "缅甸", "Myanmar"],
  [673, "BN", "文莱", "Brunei"],
  [91, "IN", "印度", "India"],
  [880, "BD", "孟加拉国", "Bangladesh"],
  [92, "PK", "巴基斯坦", "Pakistan"],
  [94, "LK", "斯里兰卡", "Sri Lanka"],
  [977, "NP", "尼泊尔", "Nepal"],
  [975, "BT", "不丹", "Bhutan"],
  [960, "MV", "马尔代夫", "Maldives"],
  [976, "MN", "蒙古", "Mongolia"],
  [850, "KP", "朝鲜", "North Korea"],
  [61, "AU", "澳大利亚", "Australia"],
  [64, "NZ", "新西兰", "New Zealand"],
  [1, "US", "美国 / 加拿大", "United States / Canada"],
  [44, "GB", "英国", "United Kingdom"],
  [353, "IE", "爱尔兰", "Ireland"],
  [33, "FR", "法国", "France"],
  [49, "DE", "德国", "Germany"],
  [34, "ES", "西班牙", "Spain"],
  [351, "PT", "葡萄牙", "Portugal"],
  [39, "IT", "意大利", "Italy"],
  [31, "NL", "荷兰", "Netherlands"],
  [32, "BE", "比利时", "Belgium"],
  [41, "CH", "瑞士", "Switzerland"],
  [43, "AT", "奥地利", "Austria"],
  [7, "RU", "俄罗斯 / 哈萨克斯坦", "Russia / Kazakhstan"],
  [55, "BR", "巴西", "Brazil"],
  [52, "MX", "墨西哥", "Mexico"],
  [54, "AR", "阿根廷", "Argentina"],
  [56, "CL", "智利", "Chile"],
  [971, "AE", "阿联酋", "United Arab Emirates"],
  [966, "SA", "沙特阿拉伯", "Saudi Arabia"],
  [20, "EG", "埃及", "Egypt"],
  [27, "ZA", "南非", "South Africa"],
  [30, "GR", "希腊", "Greece"],
  [36, "HU", "匈牙利", "Hungary"],
  [40, "RO", "罗马尼亚", "Romania"],
  [45, "DK", "丹麦", "Denmark"],
  [46, "SE", "瑞典", "Sweden"],
  [47, "NO", "挪威", "Norway"],
  [48, "PL", "波兰", "Poland"],
  [51, "PE", "秘鲁", "Peru"],
  [53, "CU", "古巴", "Cuba"],
  [57, "CO", "哥伦比亚", "Colombia"],
  [58, "VE", "委内瑞拉", "Venezuela"],
  [90, "TR", "土耳其", "Turkey"],
  [93, "AF", "阿富汗", "Afghanistan"],
  [98, "IR", "伊朗", "Iran"],
  [211, "SS", "南苏丹", "South Sudan"],
  [212, "MA", "摩洛哥", "Morocco"],
  [213, "DZ", "阿尔及利亚", "Algeria"],
  [216, "TN", "突尼斯", "Tunisia"],
  [218, "LY", "利比亚", "Libya"],
  [220, "GM", "冈比亚", "Gambia"],
  [221, "SN", "塞内加尔", "Senegal"],
  [222, "MR", "毛里塔尼亚", "Mauritania"],
  [223, "ML", "马里", "Mali"],
  [224, "GN", "几内亚", "Guinea"],
  [225, "CI", "科特迪瓦", "Côte d'Ivoire"],
  [226, "BF", "布基纳法索", "Burkina Faso"],
  [227, "NE", "尼日尔", "Niger"],
  [228, "TG", "多哥", "Togo"],
  [229, "BJ", "贝宁", "Benin"],
  [230, "MU", "毛里求斯", "Mauritius"],
  [231, "LR", "利比里亚", "Liberia"],
  [232, "SL", "塞拉利昂", "Sierra Leone"],
  [233, "GH", "加纳", "Ghana"],
  [234, "NG", "尼日利亚", "Nigeria"],
  [235, "TD", "乍得", "Chad"],
  [236, "CF", "中非", "Central African Republic"],
  [237, "CM", "喀麦隆", "Cameroon"],
  [238, "CV", "佛得角", "Cape Verde"],
  [239, "ST", "圣多美和普林西比", "São Tomé and Príncipe"],
  [240, "GQ", "赤道几内亚", "Equatorial Guinea"],
  [241, "GA", "加蓬", "Gabon"],
  [242, "CG", "刚果（布）", "Republic of the Congo"],
  [243, "CD", "刚果（金）", "DR Congo"],
  [244, "AO", "安哥拉", "Angola"],
  [245, "GW", "几内亚比绍", "Guinea-Bissau"],
  [246, "IO", "英属印度洋领地", "British Indian Ocean Territory"],
  [247, "AC", "阿森松岛", "Ascension Island"],
  [248, "SC", "塞舌尔", "Seychelles"],
  [249, "SD", "苏丹", "Sudan"],
  [250, "RW", "卢旺达", "Rwanda"],
  [251, "ET", "埃塞俄比亚", "Ethiopia"],
  [252, "SO", "索马里", "Somalia"],
  [253, "DJ", "吉布提", "Djibouti"],
  [254, "KE", "肯尼亚", "Kenya"],
  [255, "TZ", "坦桑尼亚", "Tanzania"],
  [256, "UG", "乌干达", "Uganda"],
  [257, "BI", "布隆迪", "Burundi"],
  [258, "MZ", "莫桑比克", "Mozambique"],
  [260, "ZM", "赞比亚", "Zambia"],
  [261, "MG", "马达加斯加", "Madagascar"],
  [262, "RE", "留尼汪 / 马约特", "Réunion / Mayotte"],
  [263, "ZW", "津巴布韦", "Zimbabwe"],
  [264, "NA", "纳米比亚", "Namibia"],
  [265, "MW", "马拉维", "Malawi"],
  [266, "LS", "莱索托", "Lesotho"],
  [267, "BW", "博茨瓦纳", "Botswana"],
  [268, "SZ", "斯威士兰", "Eswatini"],
  [269, "KM", "科摩罗", "Comoros"],
  [290, "SH", "圣赫勒拿", "Saint Helena"],
  [291, "ER", "厄立特里亚", "Eritrea"],
  [297, "AW", "阿鲁巴", "Aruba"],
  [298, "FO", "法罗群岛", "Faroe Islands"],
  [299, "GL", "格陵兰", "Greenland"],
  [350, "GI", "直布罗陀", "Gibraltar"],
  [352, "LU", "卢森堡", "Luxembourg"],
  [354, "IS", "冰岛", "Iceland"],
  [355, "AL", "阿尔巴尼亚", "Albania"],
  [356, "MT", "马耳他", "Malta"],
  [357, "CY", "塞浦路斯", "Cyprus"],
  [358, "FI", "芬兰", "Finland"],
  [359, "BG", "保加利亚", "Bulgaria"],
  [370, "LT", "立陶宛", "Lithuania"],
  [371, "LV", "拉脱维亚", "Latvia"],
  [372, "EE", "爱沙尼亚", "Estonia"],
  [373, "MD", "摩尔多瓦", "Moldova"],
  [374, "AM", "亚美尼亚", "Armenia"],
  [375, "BY", "白俄罗斯", "Belarus"],
  [376, "AD", "安道尔", "Andorra"],
  [377, "MC", "摩纳哥", "Monaco"],
  [378, "SM", "圣马力诺", "San Marino"],
  [379, "VA", "梵蒂冈", "Vatican City"],
  [380, "UA", "乌克兰", "Ukraine"],
  [381, "RS", "塞尔维亚", "Serbia"],
  [382, "ME", "黑山", "Montenegro"],
  [383, "XK", "科索沃", "Kosovo"],
  [385, "HR", "克罗地亚", "Croatia"],
  [386, "SI", "斯洛文尼亚", "Slovenia"],
  [387, "BA", "波黑", "Bosnia and Herzegovina"],
  [389, "MK", "北马其顿", "North Macedonia"],
  [420, "CZ", "捷克", "Czech Republic"],
  [421, "SK", "斯洛伐克", "Slovakia"],
  [423, "LI", "列支敦士登", "Liechtenstein"],
  [500, "FK", "福克兰群岛", "Falkland Islands"],
  [501, "BZ", "伯利兹", "Belize"],
  [502, "GT", "危地马拉", "Guatemala"],
  [503, "SV", "萨尔瓦多", "El Salvador"],
  [504, "HN", "洪都拉斯", "Honduras"],
  [505, "NI", "尼加拉瓜", "Nicaragua"],
  [506, "CR", "哥斯达黎加", "Costa Rica"],
  [507, "PA", "巴拿马", "Panama"],
  [508, "PM", "圣皮埃尔和密克隆", "Saint Pierre and Miquelon"],
  [509, "HT", "海地", "Haiti"],
  [590, "GP", "瓜德罗普", "Guadeloupe"],
  [591, "BO", "玻利维亚", "Bolivia"],
  [592, "GY", "圭亚那", "Guyana"],
  [593, "EC", "厄瓜多尔", "Ecuador"],
  [594, "GF", "法属圭亚那", "French Guiana"],
  [595, "PY", "巴拉圭", "Paraguay"],
  [596, "MQ", "马提尼克", "Martinique"],
  [597, "SR", "苏里南", "Suriname"],
  [598, "UY", "乌拉圭", "Uruguay"],
  [599, "CW", "库拉索 / 荷属加勒比", "Curaçao / Caribbean Netherlands"],
  [670, "TL", "东帝汶", "Timor-Leste"],
  [672, "NF", "诺福克岛", "Norfolk Island"],
  [674, "NR", "瑙鲁", "Nauru"],
  [675, "PG", "巴布亚新几内亚", "Papua New Guinea"],
  [676, "TO", "汤加", "Tonga"],
  [677, "SB", "所罗门群岛", "Solomon Islands"],
  [678, "VU", "瓦努阿图", "Vanuatu"],
  [679, "FJ", "斐济", "Fiji"],
  [680, "PW", "帕劳", "Palau"],
  [681, "WF", "瓦利斯和富图纳", "Wallis and Futuna"],
  [682, "CK", "库克群岛", "Cook Islands"],
  [683, "NU", "纽埃", "Niue"],
  [685, "WS", "萨摩亚", "Samoa"],
  [686, "KI", "基里巴斯", "Kiribati"],
  [687, "NC", "新喀里多尼亚", "New Caledonia"],
  [688, "TV", "图瓦卢", "Tuvalu"],
  [689, "PF", "法属波利尼西亚", "French Polynesia"],
  [690, "TK", "托克劳", "Tokelau"],
  [691, "FM", "密克罗尼西亚", "Micronesia"],
  [692, "MH", "马绍尔群岛", "Marshall Islands"],
  [961, "LB", "黎巴嫩", "Lebanon"],
  [962, "JO", "约旦", "Jordan"],
  [963, "SY", "叙利亚", "Syria"],
  [964, "IQ", "伊拉克", "Iraq"],
  [965, "KW", "科威特", "Kuwait"],
  [967, "YE", "也门", "Yemen"],
  [968, "OM", "阿曼", "Oman"],
  [970, "PS", "巴勒斯坦", "Palestine"],
  [972, "IL", "以色列", "Israel"],
  [973, "BH", "巴林", "Bahrain"],
  [974, "QA", "卡塔尔", "Qatar"],
  [992, "TJ", "塔吉克斯坦", "Tajikistan"],
  [993, "TM", "土库曼斯坦", "Turkmenistan"],
  [994, "AZ", "阿塞拜疆", "Azerbaijan"],
  [995, "GE", "格鲁吉亚", "Georgia"],
  [996, "KG", "吉尔吉斯斯坦", "Kyrgyzstan"],
  [998, "UZ", "乌兹别克斯坦", "Uzbekistan"],
];

function isZhLocale(locale) {
  const value = String(locale || "").toLowerCase();
  return value.indexOf("zh") === 0 || value.indexOf("yue") === 0;
}

export function normalizeCountryCode(value, fallback) {
  const defaultCode = fallback === undefined ? 86 : fallback;
  if (value === null || value === undefined || value === "") {
    return defaultCode;
  }
  const parsed = parseInt(String(value).replace(/^\+/, ""), 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : defaultCode;
}

export function isValidLocalPhone(phone) {
  return /^\d{4,15}$/.test(String(phone || "").trim());
}

export function buildCountryOptions(locale) {
  const useZh = isZhLocale(locale);
  return COUNTRY_CALLING_CODES.map(function (row) {
    const code = row[0];
    const iso = row[1];
    const zh = row[2];
    const en = row[3];
    const name = useZh ? zh : en;
    return {
      value: code,
      iso: iso,
      name: name,
      label: name + " (+" + code + ")",
      search: (zh + " " + en + " " + iso + " " + code + " +" + code).toLowerCase(),
    };
  });
}
